import * as yup from 'yup';

export const formTitle = 'intermediary.serviceInfo.formTitle';

export const notificationContactSchema = yup.object({
  contactFirstName: yup
    .string()
    .default('')
    .required('intermediary.validation.firstNameIsRequired')
    .min(3, 'intermediary.validation.min3')
    .max(300, 'intermediary.validation.max300')
    .label(formTitle),
  contactLastName: yup
    .string()
    .default('')
    .required('intermediary.validation.lastNameIsRequired')
    .min(3, 'intermediary.validation.min3')
    .max(300, 'intermediary.validation.max300')
    .label(formTitle),
  contactPhone: yup
    .string()
    .max(20, 'intermediary.validation.max20')
    .default('')
    .notRequired()
    .label(formTitle),
  contactEmail: yup
    .string()
    .email('intermediary.validation.emailIsInvalid')
    .default('')
    .required('intermediary.validation.emailIsRequired')
    .min(3, 'intermediary.validation.min3')
    .max(300, 'intermediary.validation.max300')
    .label(formTitle)
});

export const serviceSchema = yup.object({
  serviceNameFin: yup
    .string()
    .min(3, 'intermediary.validation.min3')
    .required('intermediary.validation.nameIsRequired')
    .default('')
    .label(formTitle),
  serviceNameEng: yup
    .string()
    .min(3, 'intermediary.validation.min3')
    .required('intermediary.validation.nameIsRequired')
    .default('')
    .label(formTitle),
  serviceNameSve: yup
    .string()
    .min(3, 'intermediary.validation.min3')
    .required('intermediary.validation.nameIsRequired')
    .default('')
    .label(formTitle),
  serviceFunctionalDesc: yup
    .string()
    .min(3, 'intermediary.validation.min3')
    .required('intermediary.validation.functionalDescriptionIsRequired')
    .default('')
    .label(formTitle),
  lawSection: yup.object({
    fivePointOne: yup
      .boolean()
      .default(false)
      .label(formTitle),
    fivePointTwo: yup
      .boolean()
      .default(false)
      .label(formTitle),
    fivePointThree: yup
      .boolean()
      .default(false)
      .label(formTitle)
  }),
  notificationContacts: yup
    .array()
    .of(notificationContactSchema)
    .default([notificationContactSchema.cast({})])
});

export const schema = yup.object({
  serviceData: yup.object({
    services: yup
      .array()
      .of(serviceSchema)
      .default([serviceSchema.cast({})])
      .label(formTitle)
  })
});
